import React from "react";
import { Link } from "react-router-dom";

const BusinessPlanFillingInstructions = () => {
  return (
    <div className="content">
      <p>
        {/* <strong>
          Agora Emprega - Competição de Planos de Negócios (CPN) é implementada
          pela Secretaria de Estado da Juventude e Emprego (SEJE) através do
          Instituto Nacional da Juventude IP (INJ, IP), como parte do Programa
          Emprega com o apoio do Banco Mundial. O objectivo da CPN é facilitar
          acesso ao financiamento para jovens Moçambicanos/as com idades entre
          18 e 35 anos e impulsionar o crescimento económico inclusivo. O Agora
          Emprega apenas irá financiar projectos de categoria ambiental C. Para
          mais detalhes sobre as actividades não elegíveis ao financiamento,
          consulte a lista{" "}
          <a
            href="https://agoraemprega.seje.gov.mz/lista-negativa-de-actividades-nao-elegiveis-para-financiamento/"
            target="_blank"
            rel="noopener noreferrer"
          >
            aqui
          </a>
          .
        </strong> */}
      </p>
      <h5>INSTRUÇÕES GERAIS DE PREENCHIMENTO</h5>
      <p>
        Todas as secções deste formulário devem ser preenchidas antes do envio.
        Ao preencher o plano de negócio pelo “website”, depois de concluído,
        lembre-se de sempre <strong>“Salvar”</strong> e{" "}
        <strong>“Submeter”</strong>.
      </p>
      <p>
        Não é necessário preencher o formulário de uma única vez. O candidato
        pode preencher progressivamente, bastando assegurar que seleciona a
        opção <strong>“Salvar”</strong> para gravar a informação preenchida.
        Sempre que quiser continuar com o preenchimento, selecione a opção{" "}
        <strong>
          “Editar Plano de Negócio”. Uma vez terminado o preenchimento do seu
          Plano de Negócio e tendo a certeza de que não pretende fazer qualquer
          alteração, selecione a opção “Submeter”. Uma vez submetido, não é
          possivel voltar a editar o Plano de Negócio".
        </strong>
      </p>
      <p>
        <strong>
          Ao preencher as tabelas financeiras na Secção 7, digite os números sem
          vírgulas, espaços ou pontos. É importante que o candidato, conserve o
          detalhe da informação que for a usar para preencher a tabela 7.1 e 7.3
          do formulário de plano de negócio, pois esta será solicitada pela
          equipa técnica da CPN.
        </strong>
      </p>
      <p>
        A equipa de implementação da CPN acusará o recebimento através do
        endereço de email e/ou SMS para o candidato/a apresentado na sua
        candidatura. Note que deverá inserir no seu plano de negócio o{" "}
        <strong>Número Único de Referência (NUR)</strong> que lhe foi atribuído
        aquando da candidatura.
      </p>
      <p>
        <strong>
          Ao preencher as secções do formulário, não escreva o nome da sua
          empresa ou dos sócios. Se em determinada secção for necessária a sua
          identificação, por favor use o NUR
        </strong>
        .
      </p>
      <p>
        Ao longo do processo é possível que seja contactado por um/a
        representante da nossa equipa para fornecer mais informações. Por favor,
        reconfirme que o endereço de e-mail de contacto do candidato/a principal
        e o número de telefone inseridos no formulário estão correctos.
      </p>
      <p>
        Se tiver alguma dúvida sobre a sua candidatura, não hesite em enviar-nos
        um e-mail para esclarecimentos através de agoraemprega@seje.gov.mz.
        Receberá uma resposta em 36 horas úteis. Alternativamente, pode ligar
        para as seguintes linhas de apoio{" "}
        <strong>(+258) 85 730 5231 ou (+258) 87 730 5236</strong>.
      </p>
      <p>
        <strong>
          Todas as secções devem ser obrigatoriamente respondidas para a
          candidatura ser considerada válida. Antes de submeter, certifique-se
          que respondeu a todas elas.
        </strong>
      </p>
      <p>
        <strong>
          Tentativa provada de dupla inscrição é punida com desclassificação.
        </strong>
      </p>
    </div>
  );
};

export default BusinessPlanFillingInstructions;
